import Service from "../Service";
const resource = "TasRawMaterialAnalysisDetail/";

export default {
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },
    updateStatus(obj, requestID) {
        return Service.post(resource + "updateStatus", obj, {
            params: { requestID: requestID },
        });
    },
    updateStatusList(list, requestID) {
        return Service.post(resource + "updateStatusList", list, {
            params: { requestID: requestID },
        });
    },
}